import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { RefetchFn } from "@msuite/ui/query";
import React from "react";
import { Can } from "@/components/citadel";
import { AutoIntegrationModal } from "@/modals/integrations/auto-integration-modal";
import { AddVehicleModal } from "@/modals/vehicles/add-vehicle-modal";

/** Props Interface */
interface VehiclesMenuProps {
	refetch: RefetchFn;
}

export function VehiclesMenu({ refetch }: VehiclesMenuProps) {
	/** Hooks */
	const { t } = useTranslation();
	const addVehicleModal = useDisclosure();
	const autoIntegrationWebfleetModal = useDisclosure();

	/** Render */
	return (
		<React.Fragment>
			{/* Both offers end in a lorry being taken into the fleet — one by hand, one by matching
			    the telematics account against it — so both follow `create Vehicle`. */}
			<Can
				action="create"
				subject="Vehicle"
			>
				<Button
					icon={<Icon name="Blocks" />}
					variant="primary"
					onClick={autoIntegrationWebfleetModal.onOpen}
				>
					{t("integrations.webfleet_auto_integration")}
				</Button>
				<Button
					icon={<Icon name="Plus" />}
					variant="primary"
					onClick={addVehicleModal.onOpen}
					data-cy="add-vehicle-button"
				>
					{t("vehicles.add_vehicle")}
				</Button>
			</Can>
			{addVehicleModal.isOpen && (
				<AddVehicleModal
					isOpen={addVehicleModal.isOpen}
					onClose={addVehicleModal.onClose}
					onComplete={refetch}
				/>
			)}
			{autoIntegrationWebfleetModal.isOpen && (
				<AutoIntegrationModal
					isOpen={autoIntegrationWebfleetModal.isOpen}
					onClose={autoIntegrationWebfleetModal.onClose}
					integrationType="webfleet"
					onComplete={async () => {
						await refetch?.();
					}}
				/>
			)}
		</React.Fragment>
	);
}
